import CuentaExpedienteGrid from '../../../../components/controls/CuentaExpedienteGrid';
import CuentaCertificadoEscribanoGrid from '../../../../components/controls/CuentaCertificadoEscribanoGrid';
import RelacionesCuentasGrid from '../../../../components/controls/RelacionesCuentasGrid';
import ControladoresCuentasGrid from '../../../../components/controls/ControladoresCuentasGrid';
import ZonasEntregaGrid from '../../../../components/controls/ZonasEntregaGrid';
import CuentaPlanesPagosGrid from '../../../../components/controls/CuentaPlanesPagosGrid';
import CuentaEmisionEjecucionForm from '../../../../components/controls/CuentaEmisionEjecucionForm';
import { OPERATION_MODE, TRIBUTO_TYPE } from '@laramie/ui';
import CuentaAplicacionCreditosModal from '../../../../components/controls/CuentaAplicacionCreditosModal';
import CuentaCondonacionModal from '../../../../components/controls/CuentaCondonacionModal';
import CuentaInformeDeuda from '../../../../components/controls/CuentaInformeDeuda';
import Modal from '../../../../components/common/Modal';
import { TIPS } from '../../../../consts/tips';

const MenuLateral = ({ state, listExpedientes, listDireccionesRelacionadas, UpdateEntity, HidePopupMenu }) => {

    const getTitle = () => {
        if (state.menues.expedientes) return 'Expedientes';
        if (state.menues.certificadosEscribanos) return 'Certificados escribanos';
        if (state.menues.relacionesCuentas) return 'Relaciones con otras cuentas';
        if (state.menues.controladoresCuentas) return 'Controladores de la cuenta';
        if (state.menues.zonasEntrega) return 'Zonas de entrega';
        if (state.menues.aplicacionCreditos) return 'Aplicación de créditos';
        if (state.menues.condonacion) return 'Condonación de deuda';
        if (state.menues.planesPago) return 'Planes de pago';
        if (state.menues.liquidaciones) return 'Liquidaciones';
        if (state.menues.informeDeuda) return 'Informe de deuda';
        return '';
    };

    const getTipName = () => {
        if (state.menues.expedientes) return TIPS.NAME.MODALS.EXPEDIENTES_MODAL;
        if (state.menues.certificadosEscribanos) return TIPS.NAME.MODALS.CERTIFICADOS_ESCRIBANOS_MODAL;
        if (state.menues.relacionesCuentas) return TIPS.NAME.MODALS.RELACIONES_CUENTAS_MODAL;
        if (state.menues.controladoresCuentas) return TIPS.NAME.MODALS.CONTROLADORES_CUENTAS_MODAL;
        if (state.menues.zonasEntrega) return TIPS.NAME.MODALS.ZONAS_ENTREGA_MODAL;
        if (state.menues.aplicacionCreditos) return TIPS.NAME.MODALS.APLICACION_CREDITOS_MODAL;
        if (state.menues.condonacion) return TIPS.NAME.MODALS.CONDONACION_MODAL;
        if (state.menues.planesPago) return TIPS.NAME.MODALS.PLANES_PAGO_MODAL;
        if (state.menues.liquidaciones) return TIPS.NAME.MODALS.LIQUIDACIONES_MODAL;
        if (state.menues.informeDeuda) return TIPS.NAME.MODALS.INFORME_DEUDA_MODAL;
        return null;
    };

    const tipName = getTipName();

    return (
            <Modal
                size={state.menues.informeDeuda ? "lg" : "xl"}
                allowFullscreen={state.menues.liquidaciones}
                title={getTitle()}
                tipName={tipName}
                onEscape={HidePopupMenu}
                body={(
                        <>
                            {state.menues.expedientes && (
                                <CuentaExpedienteGrid
                                    data={{
                                        listIdExpedientes: listExpedientes
                                    }}
                                />
                            )}
                            {state.menues.certificadosEscribanos && (
                                <CuentaCertificadoEscribanoGrid
                                    data={{
                                        idCuenta: state.entity.cuenta.id
                                    }}
                                />
                            )}
                            {state.menues.relacionesCuentas && (
                                <RelacionesCuentasGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.relacionesCuentas
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.controladoresCuentas && (
                                <ControladoresCuentasGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.controladoresCuentas,
                                        idTipoTributo: state.entity.cuenta.idTipoTributo
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.zonasEntrega && (
                                <ZonasEntregaGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.zonasEntrega,
                                        listDireccionesRelacionadas: listDireccionesRelacionadas,
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.aplicacionCreditos && (
                                <CuentaAplicacionCreditosModal
                                    idCuenta={state.entity.cuenta.id}
                                    idTipoTributo={TRIBUTO_TYPE.COMERCIOS}
                                    onClickVolver={HidePopupMenu}
                                />
                            )}
                            {state.menues.condonacion && (
                                <CuentaCondonacionModal
                                    idCuenta={state.entity.cuenta.id}
                                    idTipoTributo={state.entity.cuenta.idTipoTributo}
                                    onClickVolver={HidePopupMenu}
                                />
                            )}
                            {state.menues.planesPago && (
                                <CuentaPlanesPagosGrid
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id
                                    }}
                                />
                            )}
                            {state.menues.liquidaciones && (
                                <CuentaEmisionEjecucionForm
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        idTipoTributo: state.entity.cuenta.idTipoTributo
                                    }}
                                    onDismiss={() => HidePopupMenu()}
                                />
                            )}
                            {state.menues.informeDeuda && (
                                <CuentaInformeDeuda
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        idTipoTributo: TRIBUTO_TYPE.COMERCIOS
                                    }}
                                    onDismiss={HidePopupMenu}
                                />
                            )}
                        </>
                )}
                footerClassName={!(state.menues.aplicacionCreditos || state.menues.condonacion || state.menues.informeDeuda) ? "f-align" : "d-none"}
                footer={!(state.menues.aplicacionCreditos || state.menues.condonacion || state.menues.informeDeuda) && (
                        <button className="btn back-button" data-dismiss="modal" onClick={(event) => HidePopupMenu()}>Volver</button>
                )}
            />
    )
}
export default MenuLateral
